import { render, staticRenderFns } from "./SyncErrors.vue?vue&type=template&id=61f521aa&"
import script from "./SyncErrors.vue?vue&type=script&lang=js&"
export * from "./SyncErrors.vue?vue&type=script&lang=js&"
import style0 from "./SyncErrors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports